import { Dialog, DialogContent, DialogTitle, Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBack } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";

import { triggerDebuggerAndThrow } from "../../utils/debugging-utils";
import WorkoutsListings from "../Workouts/WorkoutsListings";

const useStyles = makeStyles((theme) => ({
  drawer: {
    "& .MuiDrawer-paper": {
      width: 512,
      "& .drawer-body": {
        overflow: "auto",
        height: "85vh",
        "& .MuiPaper-root": {
          "& .MuiTypography-body1": {
            display: "block",
          },
          "& .MuiTypography-body2": {
            "& svg": {
              marginLeft: -3,
              marginTop: -2,
            },
          },
        },
      },
    },
  },
  drawerHeading: {
    height: 75,
    backgroundColor: "var(--text-primary)",
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 500,
    padding: "25px 15px",
    "& svg": {
      cursor: "pointer",
      marginRight: 15,
      marginTop: -2,
    },
  },
  mobileDialog: {
    "& .MuiDialog-paper": {
      position: "absolute",
      margin: 0,
      top: 0,
      bottom: 0,
      width: "100%",
    },
    "& .MuiDialogTitle-root": {
      height: 75,
      backgroundColor: "var(--text-primary)",
      color: "#ffffff",
      fontSize: 20,
      fontWeight: 500,
      padding: "25px 15px",
      "& svg": {
        cursor: "pointer",
        marginRight: 15,
        marginTop: -2,
      },
    },
    "& .MuiDialogContent-root": {
      overflow: "auto",
      minHeight: "fit-content",
      maxHeight: "80vh",
      "& .MuiPaper-root": {
        "& .MuiTypography-body1": {
          display: "block",
        },
        "& .MuiTypography-body2": {
          "& svg": {
            marginLeft: -3,
            marginTop: -2,
          },
        },
      },
    },
  },
}));

type PickerProps = {
  show: boolean;
  onHide: (event: object) => void;
  hasSelector: boolean;
  setShowAddWorkout: (id: string) => void;
};

function DesktopView({ show, onHide, hasSelector, setShowAddWorkout }: PickerProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Drawer anchor="right" open={show} onClose={onHide} className={classes.drawer}>
      <div className={classes.drawerHeading}>
        <ArrowBack onClick={onHide} />
        {t("Select workout")}
      </div>
      <WorkoutsListings
        handleSubmit={() =>
          triggerDebuggerAndThrow("Supposedly unused submit handler in workouts listings")
        }
        /* hasSelector={hasSelector} todo: figure out what it is */
        hasSession={false} /* todo: check what this really means */
        setShowAddWorkout={setShowAddWorkout}
        setShowWorkout={triggerDebuggerAndThrow}
      />
    </Drawer>
  );
}

function MobileView({ show, onHide, hasSelector, setShowAddWorkout }: PickerProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={show} onClose={onHide} className={classes.mobileDialog}>
      <DialogTitle>
        {t("Select workout")}
        <span onClick={onHide} className="close" style={{ cursor: "pointer" }}>
          &times;
        </span>
      </DialogTitle>
      <DialogContent>
        <WorkoutsListings
          handleSubmit={() =>
            triggerDebuggerAndThrow("Supposedly unused submit handler in workouts listings")
          }
          /* hasSelector={hasSelector} */
          hasSession={false} /* todo: check what this really means */
          setShowAddWorkout={setShowAddWorkout}
          setShowWorkout={triggerDebuggerAndThrow}
        />{" "}
      </DialogContent>
    </Dialog>
  );
}

export default function WorkoutPicker(props: PickerProps) {
  return window.innerWidth > 700 ? <DesktopView {...props} /> : <MobileView {...props} />;
}
